/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
import ParameterDataType from './ParameterDataType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterDataType (runtime) // new

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="parameterName" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="dataType" type="{}parameterDataType"/&gt; &lt;element name="modelFilterItem" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="capabilities" type="{}parameterCapabilitiesType" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ParameterFault extends MoserObject{

	parameterName = null;

	dataType = null;

	modelFilterItem = null;

	capabilities = null;



	/**
	 * Gets the value of the parameterName property.
	 * @return {String} possible object is {@link String}
	 */
	getParameterName() {
		return this.parameterName;
	}

	/**
	 * Sets the value of the parameterName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setParameterName(value) {
		var oldValue = this.parameterName;
		this.parameterName = value;
		this._setAndNotify(154, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the dataType property.
	 * @return {ParameterDataType} possible object is {@link ParameterDataType}
	 */
	getDataType() {
		return this.dataType;
	}

	/**
	 * Sets the value of the dataType property.
	 * @param {ParameterDataType} value allowed object is {@link ParameterDataType}
	 */
	setDataType(value) {
		var oldValue = this.dataType;
		this.dataType = value;
		this._setAndNotify(247, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the modelFilterItem property.
	 * @return {String} possible object is {@link String}
	 */
	getModelFilterItem() {
		return this.modelFilterItem;
	}

	/**
	 * Sets the value of the modelFilterItem property.
	 * @param {String} value allowed object is {@link String}
	 */
	setModelFilterItem(value) {
		var oldValue = this.modelFilterItem;
		this.modelFilterItem = value;
		this._setAndNotify(253, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the capabilities property.
	 * @return {ParameterCapabilitiesType} possible object is {@link ParameterCapabilitiesType}
	 */
	getCapabilities() {
		return this.capabilities;
	}

	/**
	 * Sets the value of the capabilities property.
	 * @param {ParameterCapabilitiesType} value allowed object is {@link ParameterCapabilitiesType}
	 */
	setCapabilities(value) {
		var oldValue = this.capabilities;
		this.capabilities = value;
		this._setAndNotify(254, oldValue, value, true, false);
	}

	/**
	 * Creates a new instance of <code>ParameterFault</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ParameterFault</code> object from.
	 * @return {ParameterFault} an object of type <code>ParameterFault</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createParameterFault();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ParameterFault";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 154, "parameterName", null));
		featureList.push(this.createFeature(false, true, false, 247, "dataType", ParameterDataType));
		featureList.push(this.createFeature(false, false, false, 253, "modelFilterItem", null));
		var clazz;
		if (factory) {
			clazz = factory.createParameterCapabilitiesType().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 254, "capabilities", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 154:
			this.setParameterName((value));
			break;
		case 247:
			this.setDataType((value));
			break;
		case 253:
			this.setModelFilterItem((value));
			break;
		case 254:
			this.setCapabilities((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 154:
			return this.getParameterName();
		case 247:
			return this.getDataType();
		case 253:
			return this.getModelFilterItem();
		case 254:
			return this.getCapabilities();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 154:
			return this.getParameterName();
		case 247:
			return this.getDataType();
		case 253:
			return this.getModelFilterItem();
		case 254:
			return this.getCapabilities();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ParameterFault.js